import { Controller } from "@hotwired/stimulus";

// Dismisses an element on click and sets a cookie to prevent reappearance.
// Usage: data-controller="cookie-dismiss" data-cookie-dismiss-name-value="my_cookie"
export default class extends Controller {
  static values = {
    name: String,
    maxAge: { type: Number, default: 2592000 }, // 30 days
  };

  dismiss() {
    if (this.nameValue) {
      document.cookie = `${this.nameValue}=${Date.now()}; max-age=${this.maxAgeValue}; path=/; SameSite=Lax`;
    }

    this.element.style.transition = "opacity 0.3s ease-out";
    this.element.style.opacity = "0";

    setTimeout(() => {
      this.element.remove();
    }, 300);
  }
}
